import React, {Component} from 'react'

import Registry from '../../../registry/index';

class ChatLogItemShowroomActivated extends Component {
    render() {
        let lang = Registry.get('locale');

        let room = this.props.message,
            {creator} = room;

        return (
            <div className="personal-room-activated-notification">
                <a className="profile" href={creator.getProfileURL()} target="_blank"><img src={creator.avatar_url} alt=""/> {creator.nick}</a> {lang.has_started_mybobtv_showroom}, <a href={room.url}>{lang.join_this_room}</a>!
            </div>
        )
    }

}

export default ChatLogItemShowroomActivated;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemShowroomActivated/index.js